import { API } from "aws-amplify";

type Params = {
    username: string;
    email: string;
    password: string;
}

export const createAccount = async (body: Params) => {
    return await API.post('AccountAPI', '/account', { body });
}